(function(){
    'use strict';
    angular.module('app').controller('ServiceTicketsController', ServiceTicketsController);
    ServiceTicketsController.$inject = ['ServiceRequestTicketsTableService'];
    function ServiceTicketsController(ServiceRequestTicketsTableService) {
        const vm = this;

        init();
        
        function init() {
            vm.serviceTicketsTableData = new ServiceRequestTicketsTableService().tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/ServiceTicketController.js